export default __webpack_public_path__ + "static/media/Group-927.ceed5a21.svg";